import "../../css/components/Message.scss";
import React, { useEffect } from "react";
import { features } from "../utils/features";
import line from "../../img/path.svg";
import Svg from "./Svg";
import Parser from "./HTMLParser";
import { connect } from "react-redux";
import { closeMessage } from "../store/actions/index";

const Message = props => {
  const { contentSlide, titleSlide, titleDefault, contentDefault } = props;
  const content = contentSlide || contentDefault;
  const title = titleSlide || titleDefault;
  useEffect(() => {
    if (!props.closed) {
      setTimeout(() => handleCarouselElements(props.closed), 700);
    } else if (content) {
      setTimeout(() => props.closeMessage(false), 100);
    }
  }, []);
  const handleVisibility = closed => {
    handleCarouselElements(closed);
    const userOpened = !closed;
    props.closeMessage(closed, userOpened);
  };
  const handleCarouselElements = isClosed => {
    if (features.phone) return;
    const message = document.getElementById("popupMessage").offsetHeight;
    const popup = document.getElementById("message-wrapper").getBoundingClientRect().height;
    const footer = popup || message;
    const bullets = document.getElementsByClassName("swiper-pagination-bullets");
    bullets.forEach(bullet => {
      if (isClosed) {
        bullet.classList.add("to-bottom");
      } else {
        bullet.classList.remove("to-bottom");
        bullet.style["padding-bottom"] = `${footer}px`;
      }
    });
    const arrowsBottom = document.getElementsByClassName("arrow-down");
    arrowsBottom.forEach(arrow => {
      if (isClosed) {
        arrow.classList.add("to-bottom");
      } else {
        arrow.classList.remove("to-bottom");
        arrow.style["padding-bottom"] = `${footer}px`;
      }
    });
  };
  return (
    <div id="popupMessage" onClick={() => handleVisibility(!props.closed)}>
      <div className={`message-bg ${props.closed ? "closed" : ""}`}></div>
      <div className={`${props.closed ? "closed" : ""} arrowIcon ${!content ? "notShow" : ""}`}>
        <Svg svg={line} />
      </div>
      <div id="message-wrapper" className={props.closed ? "closed" : ""}>
        {title && <div className="message-title">{Parser(title)}</div>}
        <div className="message-content">{Parser(content)}</div>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    closed: state.carouselStore.message.closed,
    contentSlide: state.carouselStore.message.slide.content,
    titleSlide: state.carouselStore.message.slide.title,
    contentDefault: state.carouselStore.message.default.content,
    titleDefault: state.carouselStore.message.default.title,
  };
};
const mapDispatchToProps = dispatch => ({
  closeMessage: (closed, userOpened) => dispatch(closeMessage(closed, userOpened)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Message);
